import { get, post } from '../axios'

// 查询国家列表
export function common_queryCountryInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/common/queryCountryInfo`,
    map,
    option
  ).then(response => response)
}

// 查询四要素列表
export function common_querySiteInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/common/querySiteInfo`,
    map,
    option
  ).then(response => response)
}

// 查询省州列表
export function common_queryStateInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/common/queryStateInfo`,
    map,
    option
  ).then(response => response)
}

// 查询语言列表
export function common_queryLanguageInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/common/queryLanguageInfo`,
    map,
    option
  ).then(response => response)
}

// 上传文件
export function common_uploadFile_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/common/uploadFile`,
    map,
    option
  ).then(response => response)
}

// 查询四要素集合
export function common_querySiteInfo_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMON}/common/querySiteInfo`,
    map,
    option
  ).then(response => response)
}

//  查询语言
//  查询条件四要素
//  {
//   brandId: 1,
//   channelId: 1,
//   siteId: 1,
//   terminalId: 1
//   }
export function common_lang_get(map, option) {
  return post(
    `${process.env.VUE_APP_LANG}/mdm/site/v2/get-site`,
    map,
    option
  ).then(response => response)
}

export function common_lang_getAll(map, option) {
  return get(`${process.env.VUE_APP_LANG}/mdm/lang/list`, map, option).then(
    response => response
  )
}
